"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrayObservable = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Observable2 = require("../Observable");

var _ScalarObservable = require("./ScalarObservable");

var _EmptyObservable = require("./EmptyObservable");

var _isScheduler = require("../util/isScheduler");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayObservable =
/*#__PURE__*/
function (_Observable) {
  (0, _inherits2.default)(ArrayObservable, _Observable);

  function ArrayObservable(array, scheduler) {
    var _this;

    (0, _classCallCheck2.default)(this, ArrayObservable);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ArrayObservable).call(this));
    _this.array = array;
    _this.scheduler = scheduler;

    if (!scheduler && array.length === 1) {
      _this._isScalar = true;
      _this.value = array[0];
    }

    return _this;
  }

  (0, _createClass2.default)(ArrayObservable, [{
    key: "_subscribe",
    value: function _subscribe(subscriber) {
      var index = 0;
      var array = this.array;
      var count = array.length;
      var scheduler = this.scheduler;

      if (scheduler) {
        return scheduler.schedule(ArrayObservable.dispatch, 0, {
          array: array,
          index: index,
          count: count,
          subscriber: subscriber
        });
      } else {
        for (var i = 0; i < count && !subscriber.closed; i++) {
          subscriber.next(array[i]);
        }

        subscriber.complete();
      }
    }
  }], [{
    key: "create",
    value: function create(array, scheduler) {
      return new ArrayObservable(array, scheduler);
    }
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */

  }, {
    key: "of",
    value: function of() {
      for (var _len = arguments.length, array = new Array(_len), _key = 0; _key < _len; _key++) {
        array[_key] = arguments[_key];
      }

      var scheduler = array[array.length - 1];

      if ((0, _isScheduler.isScheduler)(scheduler)) {
        array.pop();
      } else {
        scheduler = null;
      }

      var len = array.length;

      if (len > 1) {
        return new ArrayObservable(array, scheduler);
      } else if (len === 1) {
        return new _ScalarObservable.ScalarObservable(array[0], scheduler);
      } else {
        return new _EmptyObservable.EmptyObservable(scheduler);
      }
    }
  }, {
    key: "dispatch",
    value: function dispatch(state) {
      var array = state.array,
          index = state.index,
          count = state.count,
          subscriber = state.subscriber;

      if (index >= count) {
        subscriber.complete();
        return;
      }

      subscriber.next(array[index]);

      if (subscriber.closed) {
        return;
      }

      state.index = index + 1;
      this.schedule(state);
    }
  }]);
  return ArrayObservable;
}(_Observable2.Observable);

exports.ArrayObservable = ArrayObservable;